import React from 'react';
import PayrollReceiptCard from './PayrollReceiptCard';
import { EmptyState, SkeletonCards } from '../../../components/app2';

/**
 * Cuadrícula de recibos del portal del empleado (rediseño jul-2026).
 * Estados: cargando (skeletons con el mismo layout), vacío y con datos.
 */
const PayrollReceiptsList = ({ receipts, onDownload, loading }) => {
  if (loading) return <SkeletonCards count={6} height={300} min={250} />;

  if (!receipts || receipts.length === 0) {
    return (
      <EmptyState
        icon="receipt_long"
        title="No se encontraron recibos"
        text="No hay recibos de nómina disponibles para los filtros seleccionados. Intenta ajustar los criterios de búsqueda."
      />
    );
  }

  return (
    <div>
      <div
        style={{
          display: 'flex', alignItems: 'baseline', justifyContent: 'space-between',
          flexWrap: 'wrap', gap: 8, marginBottom: 12,
        }}
      >
        <h2 className="a2-card-title" style={{ fontSize: '1.15rem' }}>
          Recibos de nómina
          <span style={{ font: "500 .9rem 'Hanken Grotesk'", color: 'var(--muted)', marginLeft: 8 }}>
            {receipts.length}
          </span>
        </h2>
        <span style={{ font: "500 .8rem 'Hanken Grotesk'", color: 'var(--muted)' }}>
          Más recientes primero
        </span>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(250px,1fr))', gap: 12 }}>
        {receipts.map((receipt) => (
          <PayrollReceiptCard key={receipt?.id} receipt={receipt} onDownload={onDownload} />
        ))}
      </div>
    </div>
  );
};

export default PayrollReceiptsList;
